import React from "react";
import classes from './Footer.module.css'
const Footer = (props) => {
    return (
        <footer className={classes.textCenter}><small>&copy; Copyright 2022-2023, CryptoBroski's</small></footer>
    )

};

export default Footer;